import React from 'react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  PleaseChooseIcon: {
    id: 'Please choose an icon as source for this element',
    defaultMessage: 'Please choose an icon as source for this element',
  },
});

const View = (props) => {
  const { data } = props;
  const intl = useIntl();
  const icon = data.icon?.[0];
  return (
    <div className="numbers icon-block">
      {!icon && props.isEditMode && (
        <Message>
          <div className="grid-teaser-item default">
          </div>
        </Message>
      )}
      {icon && (
        <img
          src={flattenToAppURL(`${icon['@id']}/@@images/image/teaser`)}
          alt="placeholder"
        />
      )}
      {data.heading? <h3 className="icon-heading headline">{data.heading}</h3> : <h3 className="icon-heading headline">123</h3>}
      {data.description && data.description.data ? (
        <div
          className="numbers icon-description"
          dangerouslySetInnerHTML={{ __html: data.description.data }}
        />
      ) : (
        // backwards compatibility for non-richtext data
        <p>Text</p>
      )}
    </div>
  );
};

export default View;
